import { render, staticRenderFns } from "./ButtonIconRound.vue?vue&type=template&id=9956d826"
import script from "./ButtonIconRound.vue?vue&type=script&lang=js"
export * from "./ButtonIconRound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports